import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < MOBILE_BREAKPOINT ||
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  });

  React.useEffect(() => {
    const onChange = () => {
      setIsMobile(
        window.innerWidth < MOBILE_BREAKPOINT ||
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
      );
    };

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
